import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="border-t border-emerald-200/10 bg-emerald-950/80 backdrop-blur-xl md:fixed md:bottom-0 md:left-0 md:right-0 md:z-40">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-4 px-4 py-5 sm:flex-row sm:px-6">
        <p className="text-sm text-emerald-200/90">Built by Srinesh Selvaraj</p>

        <div className="flex items-center gap-3">
          <a
            href="https://linkedin.com/in/srinesh-selvaraj"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-button"
            aria-label="Open LinkedIn profile"
          >
            <FaLinkedin className="h-5 w-5" />
          </a>
          <a
            href="https://github.com/srineshselvaraj"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-button"
            aria-label="Open GitHub profile"
          >
            <FaGithub className="h-5 w-5" />
          </a>
          <a
            href="mailto:srineshselvaraj@gmail.com"
            className="icon-button"
            aria-label="Send email"
          >
            <FaEnvelope className="h-5 w-5" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 